'use client';

import { c as _c } from "react/compiler-runtime";
import Script from 'next/script';
import { getENV } from '../../utils/env';
export const OptimizelyLegacy = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const projectID = getENV("NEXT_PUBLIC_OPTIMIZELY_PROJECT_ID");
    t0 = <Script id="optimizely-script" src={`https://cdn.optimizely.com/js/${projectID}.js`} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};